/* eslint-disable react/require-default-props */
import React, { useMemo, useRef } from 'react';
import { Loader, Text, Button } from '@ui';
import { translate } from '@utils/i18n';
import Chip from '@components/Chip/chip';
import useIIMRuns from '../../hooks/useIIMRuns';
import SubmissionItem from './SubmissionItem';
import './styles.scss';
export default function SubmissionsTimeline({ inspectionId }) {
    const { data: submissions, isLoading, isError, error, refetch } = useIIMRuns(inspectionId);
    const listContainer = useRef(null);
    const sortedSubmissions = submissions
        ? [...submissions].sort((a, b) => new Date(b.startedAt).getTime() - new Date(a.startedAt).getTime())
        : [];
    // Group submissions by date
    const groupedSubmissions = useMemo(() => {
        return sortedSubmissions
            .filter(({ visibility }) => visibility !== 'tech_only')
            .reduce((acc, submission) => {
            const submissionDate = new Date(submission.startedAt);
            const date = submissionDate.toLocaleString('default', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
            const existingDate = acc.find((item) => item.date === date);
            if (!existingDate) {
                acc.push({ date, submissions: [submission] });
            }
            else {
                existingDate.submissions.push(submission);
            }
            return acc;
        }, []);
    }, [sortedSubmissions]);
    if (isLoading && !submissions) {
        return (React.createElement("div", { className: "submissions-timeline loading" },
            React.createElement("div", { className: "loadingContainer" },
                React.createElement(Loader, { size: "32" }),
                React.createElement(Text, { variant: "body", as: "p" }, translate('loading', { namespace: 'features.iim_review.submissions_timeline' })))));
    }
    if (isError) {
        return (React.createElement("div", { className: "submissions-timeline error" },
            React.createElement(Text, { variant: "body", as: "p" }, translate('error', {
                namespace: 'features.iim_review.submissions_timeline',
                message: error.message
            })),
            React.createElement(Button, { type: "button", className: "retry-button", onClick: () => {
                    void refetch();
                } }, translate('retry', { namespace: 'features.iim_review.submissions_timeline' }))));
    }
    if (!submissions || submissions.length === 0) {
        return (React.createElement("div", { className: "submissions-timeline empty" },
            React.createElement("section", { className: "workspace__section" },
                React.createElement("article", { className: "section__content" }, translate('empty', { namespace: 'features.iim_review.submissions_timeline' })))));
    }
    return (React.createElement("div", { className: "submissions-timeline" },
        React.createElement("div", { className: "timeline-header" },
            React.createElement(Text, { variant: "large", as: "h2" }, translate('title', { namespace: 'features.iim_review.submissions_timeline' })),
            React.createElement(Chip, { icon: React.createElement("i", { className: "fa-light fa-paper-plane-top" }), label: `${submissions.length} ${translate('submissions_count', {
                    namespace: 'features.iim_review.submissions_timeline',
                    count: submissions.length
                })}` })),
        React.createElement("div", { className: "timeline-content activityListContainer", ref: listContainer },
            isLoading && React.createElement(Loader, { size: "32" }),
            groupedSubmissions.map(({ date, submissions: submissionsPerDate }) => (React.createElement("section", { key: date, className: "workspace__section activityGroup" },
                React.createElement("header", { className: "dateSeparator" },
                    React.createElement(Text, { variant: "medium", as: "h2", className: "section__label" }, date),
                    React.createElement(Text, { variant: "x-small", as: "span" },
                        submissionsPerDate.length,
                        ' ',
                        translate('submissions_count', {
                            namespace: 'features.iim_review.submissions_timeline',
                            count: submissionsPerDate.length
                        })),
                    React.createElement("hr", { className: "section__split" })),
                React.createElement("div", { role: "presentation", className: "activity__list" }, submissionsPerDate.map((submission) => (React.createElement(SubmissionItem, { key: submission.id, submission: submission }))))))))));
}
